import Vue from 'vue'
import Router from 'vue-router'
import serviceRegistery from '../mixins/serviceRegistery'
import store from '../store/store'
import MainLayout from '@/views/subbrand/layout.vue'
import SubbrandRoutes from './subbrand'
import CONFIG from '../config/config'

Vue.prototype.$hostname = CONFIG.developmentMode ? CONFIG.serverBaseUrl : '/'
Vue.use(Router)

let _routes = [{
    path: '/',
    exact: 'true',
    title: 'mainLayout',
    name: 'mainLayout',
    component: MainLayout
}]

_routes = _routes.concat(SubbrandRoutes)

let _router = new Router({
    mode: 'hash',
    routes: _routes
})

var token = '';
var appUrl = location.protocol + '//' + location.host + '/';
var serviceUrl = Vue.prototype.$hostname;

_router.beforeEach((to, from, next) => {

    serviceRegistery
        .makeCall({
            method: 'POST',
            url: serviceUrl + 'services/authenticator/renew',
            headers: { 'auth-token': token }
        })
        .then(response => {
            if (token) {
                next();
            } else {
                token = response.data.token;
                store.state.appStore.utid = response.data.utid;
                if (store.state.appStore.isAdmin) {
                    _router.replace("/channel")
                } else {
                    _router.replace("/dataloader")
                }
            }

            store.state.appStore.userInfo = {
                appext: response.data.appext,
                cobrandId: response.data.cobrandId,
                userName: response.data.userName,
                applicationId: response.data.applicationId,
            }

            store.state.appStore.sessionManagement.resetSession = false
            store.state.appStore.sessionManagement.resetSession = true
            store.state.appStore.sessionManagement.beginSessionTimer = true
        })
        .catch(error => {
            if (CONFIG.developmentMode === true) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('usersession');
            }
            if (to.path != '/' && to.path != '/login') {
                window.location.assign(appUrl);
            } else {
                if (to.path == '/') { // router validation and '/'
                    store.state.appStore.utid = Math.random()
                        .toString(36)
                        .slice(2)
                    _router.replace("/login")
                } else {
                    next();
                }
            }
        })
})

export default _router